var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLampOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67035 18.2072V17.0472C6.37035 15.6572 4.48035 12.9472 4.48035 10.0672C4.48035 5.11717 9.03035 1.23717 14.1703 2.35717C16.4303 2.85717 18.4103 4.35717 19.4403 6.42717C21.5303 10.6272 19.3303 15.0872 16.1003 17.0372V18.1972C16.1003 18.4872 16.2103 19.1572 15.1403 19.1572H9.63035C8.53035 19.1672 8.67035 18.7372 8.67035 18.2072Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87036 22.1672C11.1604 21.5172 13.5804 21.5172 15.8704 22.1672",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampOn);
export default __webpack_public_path__ + "static/media/lamp-on.eeb6a06d.svg";
export { ForwardRef as ReactComponent };